import { render } from "./OpenSubscribe.vue?vue&type=template&id=6e188c7f"
import script from "./OpenSubscribe.vue?vue&type=script&lang=js"
export * from "./OpenSubscribe.vue?vue&type=script&lang=js"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__